// extracted by mini-css-extract-plugin
module.exports = {"root":"PopperPaper_root__2U7Wm","paper":"PopperPaper_paper__2AOuP"};